import { render, staticRenderFns } from "./gate.vue?vue&type=template&id=84ceb042"
import script from "./gate.ts?vue&type=script&lang=js&external"
export * from "./gate.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports